import UploadFileIcon from "@mui/icons-material/UploadFile";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import api from "../../api";
import { notif } from "../utils";

export type UploadFileType = "txt" | "csv" | "xls" | "xlsx";

const mimeMap = new Map([
  ["txt", "text/plain"],
  ["csv", "text/csv"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
]);

export interface UploadedFileInfo {
  name: string;
  originalname: string;
  extension: string;
  mimetype: string;
  size: number;
}

export interface UploadFileControlProps {
  accept: UploadFileType[];
  onUploaded?: (info: UploadedFileInfo) => void;
}

export const UploadFileControl = (props: UploadFileControlProps) => {
  const { accept, onUploaded } = props;
  const [acceptString, setAcceptString] = useState("");
  const [label, setLabel] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const items: string[] = [];
    for (const ext of props.accept) {
      items.push(ext);
      const mime = mimeMap.get(ext);
      if (mime) items.push(mime);
    }
    setAcceptString(items.join(","));
    setLabel(`Upload (${accept.map((ext) => `${ext}`).join(",")})`);
  }, [accept]);

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0] as File;
      setLoading(true);
      try {
        const result = await api.file.upload({
          data: file,
          fileName: file.name,
        });
        setLoading(false);
        if (onUploaded && result?.name) {
          const ext = result.name.split(".").pop();
          onUploaded({
            name: result.name,
            originalname: result.originalname || "",
            extension: ext || "",
            mimetype: result.mimetype || "",
            size: result.size || 0,
          });
        }
      } catch (err:any) {
        setLoading(false);
        notif(err);
      }
    }
  };

  return (
    <LoadingButton loading={loading} component="label" variant="outlined" startIcon={<UploadFileIcon />}>
      {label}
      <input type="file" accept={acceptString} hidden onChange={handleFileUpload} />
    </LoadingButton>
  );
};
